<template>
<div class="payment-wrapper">
    <div class="payment">
        <div class="form-row">
            <div class="form-field form-field-payment">
                <div class="stripe-field-wrapper">
                    <div ref="card"></div>
                </div>
                <img class="accepted-creditcards" src="https://queenslabcdn.blob.core.windows.net/odt/img/accepted-cards.jpg">
                <div class="terms">
                    <p>All prices are calculated to chosen currency through <a href="https://stripe.com" target="_blank">Stripe</a>. Swedish VAT is deducted for customers outside of the European Union. Shipping charges apply.
                    </p>
                    <p>Deliveries are effectuated by Schenker Privpak in Sweden, Postnord in Denmark and Finland and UPS for the rest of the world.  
                    </p>
                </div>
            </div> 
        </div> 
    </div>
</div>

</template>

<script>
let style = {
  base: {
    color: '#000',
    fontFamily: '"Didot-Italic", Helvetica, sans-serif',
    fontSmoothing: 'antialiased',
    fontSize: '16px',
    '::placeholder': {
      color: '#777'
    },
  },

  invalid: {
    // All of the error styles go inside of here.
  }
};

var stripe = undefined
var card = undefined

export default {
    name: "payment",
    mounted() {
        /*eslint-disable */
        stripe = Stripe(this.$store.getters.CONFIG.stripePublicKey)
        let elements = stripe.elements({locale: 'en'});

        card = elements.create('card', {style: style, hidePostalCode: true });
        card.mount(this.$refs.card);
    },
    methods: {
        placeOrder() {
            this.$store.dispatch('LOADING_START');
            let self = this
             stripe.createToken(card).then((result) => {
                self.$store.commit('CHECKOUT/UPDATE_CHECKOUT_MODEL', { property: 'sourceToken', value: result.token.id })
                self.dispatchOrder();
            }).catch(() => {
                self.$store.dispatch('LOADING_END');  
            }); 
            
        },
        dispatchOrder() {
            let form = this.$store.getters['CHECKOUT/GET_CHECKOUT_MODEL']
            form.cart = this.getCartPostModel();

            this.$store.dispatch('CHECKOUT/PURCHASE', form).then(()=> {
                this.$store.dispatch('LOADING_END'); 
                this.$store.dispatch('CART/CLEAR'); 
                this.$router.push({ name: 'OrderComplete' });
            }).catch(() => { 
                this.$store.dispatch('LOADING_END');  
            }); 
        },
        getCartPostModel() {
            let cartPostModel = []
            let cart = this.$store.getters['CART/CART']

            cart.forEach(element => {
                cartPostModel.push({
                amount: element.amount,
                id: element.product.id
                })
            })
            return cartPostModel;
        }
    }
}
</script>

<style lang="postcss">
    .payment-wrapper {  
        display: flex;
        width: 100%;
        margin-top: -1%;
    }

    .terms a {
        text-decoration: none;
        color: inherit;
    }

    .terms a:hover {
        text-decoration: underline;
    }

    .payment  {
        padding-bottom: 10%;
        width: 100%;
        order: 3;

    }
    .stripe-field-wrapper {
        display: flex;
        border: 1px solid #777;
        padding-left: 5px;
    }
    
    .StripeElement {
        width: 100%;
        background-color: white;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .StripeElement--invalid {
        border-color: #fa755a;
    }

    .StripeElement .ElementsApp input {
        font-family: 'Didot-Italic', 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Verdana, sans-serif;
    }

    .StripeElement--webkit-autofill {
        background-color: #fefde5 !important;
    }
    .accepted-creditcards { width: 35%;}

    @media screen and (max-width: 768px) {
       
       .StripeElement { 
            padding-top: 18px;
            padding-bottom: 18px;
        }
       
        h3 {
            text-align: center;
            font-size: 1.8em;
            padding-bottom: 5%;
        }
        .accepted-creditcards {
            margin-left: auto;
            margin-right: auto;
        }   
    }
</style>